import React from "react";
import StatsGrid from "../../../../../components/reusable/management/StatsGrid";

const DepartmentStatsCards = ({ stats, loading }) => {
    const cards = [
        {
            title: "Departments",
            subText: "Active departments",
            color: "#2563eb",
            icon: "briefcase",
            value: loading ? "—" : stats?.departments ?? 0,
        },
        {
            title: "Employees",
            subText: "Across all departments",
            color: "#10b981",
            icon: "users",
            value: loading ? "—" : stats?.employees ?? 0,
        },
        {
            title: "Open Tasks",
            subText: "Currently active",
            color: "#f59e0b",
            icon: "clipboardList",
            value: loading ? "—" : stats?.openTasks ?? 0,
        },
        {
            title: "Completed Today",
            subText: "Completed today",
            color: "#06b6d4",
            icon: "checkCircle",
            value: loading ? "—" : stats?.completedToday ?? 0,
        },
        {
            title: "Task Completion",
            value: loading ? "—" :
                stats?.completionRate != null
                    ? `${stats.completionRate}%`
                    : "—",
            icon: "activity",
            subText: "Overall completion rate",
        },
    ];

    return (
        <StatsGrid cards = { cards } />
    );
};

export default DepartmentStatsCards;
